import React from "react";
import { Box } from "@mui/material";
import { PriceDisplayModeToggle } from "./PriceDisplayModeToggle";
import { useMCContext } from "../contexts/useMCStates";

export const PRICE_DISPLAY_MODE_BAR_HEIGHT_PX = 36;

export const PriceDisplayModeBar = () => {
    const { factor } = useMCContext();

    return (
        <Box
            sx={{
                flexShrink: 0,
                width: "100%",
                maxWidth: "100%",
                boxSizing: "border-box",
                minHeight: PRICE_DISPLAY_MODE_BAR_HEIGHT_PX,
                py: 0.5 * factor,
                px: 2 * factor,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: "background.paper",
                borderBottom: "1px solid",
                borderColor: "divider",
                zIndex: 1000,
                overflow: "hidden",
            }}
        >
            <PriceDisplayModeToggle />
        </Box>
    );
};
